import type { ModelDefinition } from "@/shared/types";
import { buildAvailableModels } from "./model-helpers";

/**
 * The one model-list pipeline shared by every picker surface (Playground
 * chat, eval suite/judge editors, client builder Agent tab). The server
 * holds the provider keys, so the list is the full catalog. Surfaces must
 * not fork this composition.
 */
export function composeAvailableModels(): ModelDefinition[] {
  return buildAvailableModels();
}
